<script lang="ts" setup>
import { useRoute } from 'vue-router'
import TheNavbar from '../components/TheNavbar.vue'
import TheFooter from '../components/TheFooter.vue'

const route = useRoute()
</script>

<template>
  <div class="min-h-screen flex flex-col bg-white">
    <TheNavbar />
    <main class="flex-1">
      <RouterView />
    </main>
    <TheFooter v-if="!route.meta.hideFooter" />
  </div>
</template>
